import React from 'react';
import PostItem from '../post-item';

const QuoteItem = React.memo(({quote, currentUserId, isAuthorized, getQuoteRef, highlightId}) => {
    const isFollowing = quote?.author?.followingUser || false;
    return (
        <PostItem
            post={quote}
            userId={null}
            currentUserId={currentUserId}
            isAuthorized={isAuthorized}
            isFollowing={isFollowing}
            getPostRef={getQuoteRef}
            highlightId={highlightId}
        />
    );
});

export default QuoteItem;


